import Swiper from "swiper/bundle";

/**
 * Generic Swiper Component
 * Provides reusable carousel/slider functionality
 */
class SwiperComponent extends HTMLElement {
	#swiper;
	#swiperContainer;

	/**
	 * Create swiper custom element
	 */
	constructor() {
		super();
		this.#swiperContainer = this.querySelector(".Swiper-container");
		this.#init();
	}

	/**
	 * Initialize Swiper instance with configuration from data attribute
	 */
	async #init() {
		if (!this.#swiperContainer) return;

		// Get configuration from data attribute
		const configAttr = this.getAttribute("data-config");
		const config = configAttr ? JSON.parse(configAttr) : {};

		// Initialize Swiper with provided configuration
		this.#swiper = new Swiper(this.#swiperContainer, config);
	}

	/**
	 * Get Swiper instance (for external control)
	 * @returns {object} The Swiper instance
	 */
	get swiper() {
		return this.#swiper;
	}

	/**
	 * Cleanup when element is removed
	 */
	disconnectedCallback() {
		if (this.#swiper) {
			this.#swiper.destroy();
		}
	}
}

customElements.define("cd-swiper", SwiperComponent);
